<span [style.--color]="color" class="m-auto">
  <span class="icon" [inlineSVG]="iconSource" [setSVGAttributes]="{ width: width, height: height }"></span>
</span>